<template>
    <div>
        <toggle-card 
            v-for="(address, i) in localValue" v-bind:heading="getHeading(address)"
            v-bind:key="address.id" v-bind:visibility="(!address.id || address.id === 'new')"
            v-bind:can-delete="true" v-on:delete="onDelete(address, i)"
        >
            <z-select
                label="Тип адреса"
                v-model="address.type_id"
                v-validate="'required'" 
                v-bind:name="('type-' + i)"
                v-bind:id="('type-' + i)"
                data-vv-as=" "
                v-bind:data-vv-name="('type-' + i)"
                v-bind:error="errors.first('address-' + i + '.type-' + i)"
                v-bind:data-vv-scope="('address-' + i)"
            >
                <option value="" selected disabled></option>
                <option v-for="type in addressTypes" v-bind:key="type.id" v-bind:value="type.id"> {{ type.name }}</option>
            </z-select>
            <z-input-autocomplete
                label="Введите точный адрес до номера квартиры/офиса" v-model="address.address" v-bind:showOnFocus="true"
                v-bind:default="address.address" v-bind:name="('address-' + i)" v-bind:id="('address-' + i)" display-property="unrestricted_value" property="unrestricted_value" 
                return="unrestricted_value" data-vv-as=" " v-bind:data-vv-name="('address-' + i)" v-bind:error="errors.first('address-' + i + '.address-' + i)"
                v-bind:data-vv-scope="('address-' + i)" v-bind:required="true" v-validate="{'required': true}" v-bind:callback="suggestAddress" v-on:clear="onClear(address, i)"
            ></z-input-autocomplete>
            <z-button @click="saveAddress(address, i, ('address-' + i))" fit-content no-margin>Сохранить</z-button>
        </toggle-card>
        <z-button @click="addAddress" fit-content no-margin> Добавить адрес </z-button>
    </div>
</template>
<script>
    import ZInput from '@/components/ZInput';
    import ToggleCard from '@/components/ToggleCard';
    import ZSelect from '@/components/ZSelect';
    import ZButton from '@/components/ZButton';
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    export default {
        components: { ZInput, ToggleCard, ZButton, ZSelect, ZInputAutocomplete },
        props: {
            value: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            customerId: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                localValue: [],
                newAddress: {
                    id: null,
                    address: null,
                    type: {code: 'actual'}
                }
            }
        },
        created() {
            if (this.$props.value) this.localValue = Object.assign([], this.$props.value);
            this.getAddressTypes();
        },
        watch: {
            '$props.value' (newVal) {
                if(JSON.stringify(this.localValue) != JSON.stringify(newVal)) this.localValue = newVal
            },
            'localValue' (newVal) {
                this.$emit('input', newVal);
            },
        },
        computed: {
            /**
             * Список типов адресов
             */
            addressTypes() {
                return this.$store.state.address.address_types;
            }
        },
        methods: {
            /**
             * Установка заголовка у адреса
             */
            getHeading(val) {
                let type = this.addressTypes.find(item => item.id == val.type_id) || {};
                return [
                    type.name   || null,
                    val.address || null,
                ].filter(v => !!v).join(', ');
            },
            /**
             * Добавление адреса
             */
            addAddress() {
                if (!this.localValue) this.localValue = [];
                this.localValue.push(this.newAddress);
            },
            /**
             * Поиск адреса по строке
             */
            suggestAddress(string) {
                return this.$store.dispatch('deals/suggest', { string: string });
            },
            /**
             * Изменение адреса
             */
            putAddress(address) {
                this.$store.commit('showProgressBar', 'load-customer-card');
                this.$store.dispatch(('address/putAddress'), address)
                    .finally(() => this.$store.commit('hideProgressBar', 'load-customer-card'));
            },
            /**
             * Добавление адреса
             */
            postAddress() {},
            /**
             * Сохранение адреса
             */
            saveAddress(address, i, scope) {
                this.$validator.validateAll(scope).then(async valid => {
                    if (!valid) return;

                    this.$store.commit('showProgressBar', 'load-customer-card');

                    if (!address.id) address = await this.$store.dispatch('address/postAddress', address);
                    await this.$store.dispatch('customers/attachAddress', {customer_id: this.$props.customerId, address_id: address.id});
                    
                    this.$set(this.localValue, i, Object.assign({}, address));
                    this.$store.commit('hideProgressBar', 'load-customer-card');
                });
            },
            /**
             * Получение типов адреса
             */
            getAddressTypes() {
                this.$store.commit('showProgressBar', 'load-customer-card');
                this.$store.dispatch('address/getAddressTypes').finally(() => this.$store.commit('hideProgressBar', 'load-customer-card'));
            },
            /**
             * Колбек очистки адреса
             * сбрасывает адрес до дефолтного значения с сохранением типа адреса
             */
            onClear(address, i) {
                let newAddress = Object.assign({}, this.newAddress);
                newAddress.type    = address.type;
                newAddress.type_id = address.type_id;

                this.$set(this.localValue, i, Object.assign({}, newAddress));
            },
            /**
             * Модальное окно с удаением адреса
             */
            onDelete(address, i) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении адреса?', 'Действие необратимо!',
                    () => this.removeAddress(address.id, i)
                );
            },
            /**
             * Удаление адреса
             */
            async removeAddress(id, i) {
                if (id) {
                    this.$store.commit('showProgressBar', 'load-customer-card');
                    await this.$store.dispatch('customers/detachAddress', {address_id: id, customer_id: this.$props.customerId})
                        .finally(() => this.$store.commit('hideProgressBar', 'load-customer-card'));
                }

                this.localValue.splice(i, 1);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// CustomerAddress.vue?e092d9ac